var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentosRechazadosNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.04,
    height: 34.33,
    viewBox: "0 0 30.04 34.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #316094;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pictograma_-_Documentos_Rechazados",
    "data-name": "Pictograma - Documentos Rechazados",
    transform: "translate(-1531.416 -172.802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4392",
    "data-name": "Trazado 4392",
    className: "cls-1",
    d: "M1552.486,177.972a6.032,6.032,0,0,0-1.28-2.15,4.349,4.349,0,0,0-.48-.48,6.292,6.292,0,0,0-2.14-1.28,6.116,6.116,0,0,0-2.15-.38h-.01a6.273,6.273,0,0,0-2.13.37,6.154,6.154,0,0,0-2.15,1.27,3.933,3.933,0,0,0-.5.5,6.032,6.032,0,0,0-1.28,2.15h-8.95v30.04h30.04v-30.04Zm6.83,27.9h-25.75v-25.75h6.42c0-.07.01,0,.01,0h2.14a1.619,1.619,0,0,1,.01-.22,4.1,4.1,0,0,1,.57-1.93,4.326,4.326,0,0,1,1.58-1.57,4.264,4.264,0,0,1,2.13-.57h.01a4.3,4.3,0,0,1,4.28,4.29h8.6Z",
    transform: "translate(0 -0.88)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4393",
    "data-name": "Trazado 4393",
    className: "cls-1",
    d: "M1555.02,185.908l-1.465-1.465-7.114,7.114-7.127-7.127-1.465,1.465,7.125,7.128-7.122,7.122,1.472,1.465,7.117-7.12,7.112,7.115,1.472-1.465-7.118-7.117Z",
    transform: "translate(0 -0.88)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4394",
    "data-name": "Trazado 4394",
    className: "cls-1",
    d: "M1544.818,179.709a1.607,1.607,0,1,1,1.608,1.608,1.607,1.607,0,0,1-1.608-1.608",
    transform: "translate(0 -0.88)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentosRechazadosNormal);
export default __webpack_public_path__ + "static/media/documentosRechazadosNormal.acc3ae63c94db4a7b6a5b1e7d0a723f4.svg";
export { ForwardRef as ReactComponent };